import script from "./StatementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementPage.vue?vue&type=script&setup=true&lang=js"

import "./StatementPage.vue?vue&type=style&index=0&id=b916b23e&lang=scss&scoped=true"
import "./StatementPage.vue?vue&type=style&index=1&id=b916b23e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b916b23e"]])

export default __exports__